/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityStatusResponseDto {
    name: ActivityStatusResponseDto.NameEnum;
    reason?: string | null;
    /**
     * ISO 8601 date-time format in UTC timezone (e.g., 2025-02-07T10:29:55.097715Z)
     */
    dateTime?: string | null;
}
export namespace ActivityStatusResponseDto {
    export const NameEnum = {
        Pending: 'PENDING',
        Paid: 'PAID',
        Corrected: 'CORRECTED',
        Error: 'ERROR',
    } as const;
    export type NameEnum = (typeof NameEnum)[keyof typeof NameEnum];
}
